import { MutationTree } from "vuex";
import {
  MypageState,
  MypageRecipeClips,
  MypageFolderClips,
  MypageFolderOperationResult,
  MypageOperationResult,
  MypageFolders,
  MypageInquiryStatus,
  MypageFoodsRanking,
  MypageUserRanking,
  MypageHistoryRecipes,
  MypageStoreFoodsRanking,
  MypageStoreUserRanking
} from "@/types/mypage";
import { RecipeFoods } from "@/types/pantry";
import NativeClient from "@/client/native-client";

const mutations: MutationTree<MypageState> = {
  updateAddRecipe: async (state, result: MypageOperationResult | null) => {
    state.addRecipeResult = result;
  },
  updateDeleteRecipe: (state, result: MypageOperationResult | null) => {
    state.deleteRecipeResult = result;
  },
  updateRecentFavoriteRecipeList: (state, clips: MypageRecipeClips | null) => {
    state.recentFavoriteRecipeList = clips;
  },
  updateFavoriteRecipeList: (state, clips: MypageRecipeClips | null) => {
    if (clips == null) {
      // クリア
      NativeClient.sendDebugLog("Mutations.ts updateFavoriteRecipeList clear");
      state.favoriteRecipeList = null;
    } else if (state.favoriteRecipeList == null) {
      // 元のデータなし
      NativeClient.sendDebugLog("Mutations.ts updateFavoriteRecipeList initial");
      state.favoriteRecipeList = clips;
    } else {
      // 追加
      NativeClient.sendDebugLog("Mutations.ts updateFavoriteRecipeList append");
      const mergedClips = state.favoriteRecipeList.clips.concat(clips.clips);
      const newClips: MypageRecipeClips = {
        ...clips,
        clips: mergedClips
      };
      state.favoriteRecipeList = newClips;
    }
  },
  updateFolderList: (state, folders: MypageFolders | null) => {
    state.folderList = folders;
  },
  updateRegistFolder: (state, result: MypageFolderOperationResult | null) => {
    state.registFolderResult = result;
  },
  updateFolderRecipeList: (state, clips: MypageFolderClips | null) => {
    if (clips == null) {
      // クリア
      state.folderRecipeList = null;
    } else if (state.folderRecipeList == null) {
      // 元のデータなし
      state.folderRecipeList = clips;
    } else {
      // 追加
      const mergedClips = state.folderRecipeList.clips.concat(clips.clips);
      const newClips: MypageFolderClips = {
        ...clips,
        clips: mergedClips
      };
      state.folderRecipeList = newClips;
    }
  },
  updateRenameFolder: (state, result: MypageFolderOperationResult | null) => {
    state.renameFolderResult = result;
  },
  updateDeleteFolder: (state, result: MypageFolderOperationResult | null) => {
    state.deleteFolderResult = result;
  },
  updateAddFolderRecipe: (state, result: MypageFolderOperationResult | null) => {
    state.addFolderRecipeResult
  },
  updateDeleteFolderRecipe: (state, result: MypageOperationResult | null) => {
    state.deleteFolderRecipeResult = result;
  },
  updateMoveFolder: (state, result: MypageOperationResult | null) => {
    state.folderMoveResult = result;
  },
  updateFolderName: (state, folderName: string | null) => {
    state.folderName = folderName;
  },
  updateSelectedTab: (state, selected: number) => {
    NativeClient.sendDebugLog("Mutations.ts updateDisplayTab");
    state.selectedTab = selected;
  },
  updateFavoriteFoodList: (state, result: RecipeFoods | null) => {
    NativeClient.sendDebugLog("Mutations.ts updateFavoriteFoodList");
    state.favoriteFoodList = result;
  },
  updateInquiryStatus: (state, result: MypageInquiryStatus | null) => {
    NativeClient.sendDebugLog("Mutations.ts updateInquiryStatus");
    state.inquiryStatus = result;
  },
  updateUsedFoodsRanking: (state, result: MypageFoodsRanking | null) => {
    NativeClient.sendDebugLog("Mutations.ts updateUsedFoodRanking");
    state.foodsRanking = result;
  },
  updatePersonalMonthlyUsedFoodsRanking: (state, result: MypageStoreFoodsRanking | null) => {
    if (result != null) {
      if (state.personalMonthlyUsedFoodsRanking == null) {
        state.personalMonthlyUsedFoodsRanking = new Array<MypageStoreFoodsRanking>();
        state.personalMonthlyUsedFoodsRanking.push(result);
      } else {
        const index = state.personalMonthlyUsedFoodsRanking.findIndex(element => element.month == result.month);
        if (index == -1) {
          state.personalMonthlyUsedFoodsRanking.push(result);
        } else {
          state.personalMonthlyUsedFoodsRanking[index].data = result.data;
        }
      }
    }
  },
  updatePersonalMonthlyDisposedFoodsRanking: (state, result: MypageStoreFoodsRanking | null) => {
    if (result != null) {
      if (state.personalMonthlyDisposedFoodsRanking == null) {
        state.personalMonthlyDisposedFoodsRanking = new Array<MypageStoreFoodsRanking>();
        state.personalMonthlyDisposedFoodsRanking.push(result);
      } else {
        const index = state.personalMonthlyDisposedFoodsRanking.findIndex(element => element.month == result.month);
        if (index == -1) {
          state.personalMonthlyDisposedFoodsRanking.push(result);
        } else {
          state.personalMonthlyDisposedFoodsRanking[index].data = result.data;
        }
      }
    }
  },
  updateNationwideMonthlyUsedFoodsRanking: (state, result: MypageStoreFoodsRanking | null) => {
    if (result != null) {
      if (state.nationwideMonthlyUsedFoodsRanking == null) {
        state.nationwideMonthlyUsedFoodsRanking = new Array<MypageStoreFoodsRanking>();
        state.nationwideMonthlyUsedFoodsRanking.push(result);
      } else {
        const index = state.nationwideMonthlyUsedFoodsRanking.findIndex(element => element.month == result.month);
        if (index == -1) {
          state.nationwideMonthlyUsedFoodsRanking.push(result);
        } else {
          state.nationwideMonthlyUsedFoodsRanking[index].data = result.data;
        }
      }
    }
  },
  updateNationwideMonthlyDisposedFoodsRanking: (state, result: MypageStoreFoodsRanking | null) => {
    if (result != null) {
      if (state.nationwideMonthlyDisposedFoodsRanking == null) {
        state.nationwideMonthlyDisposedFoodsRanking = new Array<MypageStoreFoodsRanking>();
        state.nationwideMonthlyDisposedFoodsRanking.push(result);
      } else {
        const index = state.nationwideMonthlyDisposedFoodsRanking.findIndex(element => element.month == result.month);
        if (index == -1) {
          state.nationwideMonthlyDisposedFoodsRanking.push(result);
        } else {
          state.nationwideMonthlyDisposedFoodsRanking[index].data = result.data;
        }
      }
    }
  },
  updateUserRanking: (state, result: MypageUserRanking | null) => {
    NativeClient.sendDebugLog("Mutations.ts updateInquiryStatus");
    state.userRanking = result;
  },
  updateMonthlyUserRanking: (state, result: MypageStoreUserRanking | null) => {
    NativeClient.sendDebugLog("Mutations.ts updateInquiryStatus");
    if (result != null) {
      if (state.monthlyUsedRanking == null) {
        state.monthlyUsedRanking = new Array<MypageStoreUserRanking>();
        state.monthlyUsedRanking.push(result);
      } else {
        const index = state.monthlyUsedRanking.findIndex(element => element.month == result.month);
        if (index == -1) {
          state.monthlyUsedRanking.push(result);
        } else {
          state.monthlyUsedRanking[index].data = result.data;
        }
      }
    }
  },
  updateTopHistoryRecipe: (state, result: MypageHistoryRecipes | null) => {
    NativeClient.sendDebugLog("Mutations.ts updateTopHistoryRecipe");
    state.topHistoryRecipe = result;
  },
  updateHistoryRecipe: (state, result: MypageHistoryRecipes | null) => {
    NativeClient.sendDebugLog("Mutations.ts updateHistoryRecipe");
    if (result == null) {
      // クリア
      NativeClient.sendDebugLog("Mutations.ts updateHistoryRecipe clear");
      state.historyRecipe = null;
    } else if (state.historyRecipe == null) {
      // 元のデータなし
      NativeClient.sendDebugLog("Mutations.ts updateHistoryRecipe initial");
      state.historyRecipe = result;
    } else {
      // 追加
      NativeClient.sendDebugLog("Mutations.ts updateHistoryRecipe append");
      const mergedRecipes = state.historyRecipe.recipes.concat(result.recipes);
      const newRecipes: MypageHistoryRecipes = {
        ...result,
        recipes: mergedRecipes
      };
      state.historyRecipe = newRecipes;
    }
  },
  updateSelectedMonthIndex: (state, index: number | null) => {
    state.selectedMonthIndex = index;
  }
};

export default mutations;
